export const LENDER_BOARD_OFFER_REDUCER_PATH = "lenderOfferApi";

export const LENDER_BOARD_OFFER_SERVICE_TAG = "LenderBoardOffer";
export const LENDER_BOARD_OFFER_FILE_SERVICE_TAG = "LenderBoardOfferFile";

export const LENDER_BOARD_OFFER_RELATED_TAGS = [LENDER_BOARD_OFFER_SERVICE_TAG, LENDER_BOARD_OFFER_FILE_SERVICE_TAG];
